// resetModule

// import { getInteractionsFromTopicAndState } from 'selectors/block';
import { Block } from '@chameleoncreator/creator-app';
import { Action, initialState, State, NextState } from 'store/store';
// import { getInteractionsFromTopicAndState } from 'selectors/block';

// import getAllInteractions from 'services/apiHelpers/getAllInteractions';
import isAndroidSamsung from 'services/isAndroidSamsung';
import isAppleComputerInc from 'services/isAppleComputerInc';
import { unlockAssessment } from 'components/lib/AssessmentResults/unlockAssessment';

const isDevice = isAppleComputerInc() || isAndroidSamsung();

export const resetModule = (
  state: State = initialState,
  { data }: Action
): State => {
  const interactionsOpen = [];
  const interactionsLocked = [];

  Object.values(state.blocks).forEach(block => {
    if (block.type === 'Interaction') {
      const { id } = block;
      const lockDown = block?.props?.lockDown;

      const moduleIsFreeScrolling = state.theme.moduleIsFreeScrolling || {
        desktop: false,
        device: false,
      };

      const {
        desktop: moduleIsFreeScrollingDesktop,
        device: moduleIsFreeScrollingDevice,
      } = moduleIsFreeScrolling;

      if (!isDevice) {
        moduleIsFreeScrollingDesktop && interactionsOpen.push(id);
        !moduleIsFreeScrollingDesktop &&
          lockDown &&
          interactionsLocked.push(id);
      }

      if (isDevice) {
        moduleIsFreeScrollingDevice && interactionsOpen.push(id);
        !moduleIsFreeScrollingDevice && lockDown && interactionsLocked.push(id);
      }
    }
  });

  //

  // console.log(state.assessments);

  return {
    ...state,
    interactionsSeen: [],
    interactionsOpen: [],
    interactionsLocked,
    assessments: {},
  };
};
